export var getDefaultStyleSheet = () => ({
  containerStyle: {
    flexDirection: 'row'
  },
  itemStyle: {
    marginLeft: -8
  }
});
//# sourceMappingURL=getDefaultStyleSheet.js.map